import { render, staticRenderFns } from "./Life.vue?vue&type=template&id=6374862a&"
import script from "./Life.vue?vue&type=script&lang=js&"
export * from "./Life.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports